import { ref, watch } from 'vue'
import Storage from '@/storage'

const storageHelper = new Storage()

export function useAvatarUrl (picture) {
  const avatarUrl = ref(null)
  const loading = ref(false)
  const error = ref(false)

  const resolveAvatarUrl = (pictureData) => {
    if (!pictureData) {
      avatarUrl.value = null
      return
    }

    if (pictureData.file?.key) {
      const cloudFrontUrl = storageHelper.getAvatarCloudFrontUrl(pictureData.file.key)

      if (cloudFrontUrl) {
        avatarUrl.value = cloudFrontUrl
        return
      }
    }

    if (pictureData.url) {
      try {
        const urlObj = new URL(pictureData.url)
        const hostname = urlObj.hostname
        if (
          hostname === 'cloudfront.net' ||
          hostname.endsWith('.cloudfront.net')
        ) {
          avatarUrl.value = pictureData.url
          return
        }
      } catch (e) {
        // Invalid URL; skip to next block
      }
    }

    if (pictureData.url && pictureData.url.includes('X-Amz')) {
      const extractedKey = storageHelper.extractKeyFromPresignedUrl(pictureData.url)

      if (extractedKey) {
        const cloudFrontUrl = storageHelper.getAvatarCloudFrontUrl(extractedKey)

        if (cloudFrontUrl) {
          avatarUrl.value = cloudFrontUrl
          return
        }
      }

      avatarUrl.value = null
      return
    }

    avatarUrl.value = pictureData.url || null
  }

  watch(
    picture,
    (newPicture) => {
      loading.value = true
      error.value = false

      try {
        resolveAvatarUrl(newPicture)
      } catch (err) {
        console.error('Error resolving avatar URL:', err)
        error.value = true
        avatarUrl.value = null
      } finally {
        loading.value = false
      }
    },
    { immediate: true, deep: true }
  )

  return {
    avatarUrl,
    loading,
    error
  }
}
